import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b423d90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-alert-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_text = _resolveComponent("oxd-text")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.classes),
        role: "alert"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.contentClasses)
        }, [
          _createVNode(_component_oxd_icon, {
            name: _ctx.iconName,
            class: "oxd-alert-content-icon"
          }, null, 8, ["name"]),
          _createVNode(_component_oxd_text, {
            tag: "p",
            class: "oxd-alert-content-text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message), 1)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}